import RoleNavigation from "./RoleNavigation";
export default function AdminNav() {
  return <RoleNavigation role="facility_admin" />;
}
